// ===================== TYPES =====================
export const SET_MISSION_REQUEST_LOADING = "SET_MISSION_REQUEST_LOADING";
export const CLEAR_MISSION_REQUEST_MESSAGE = "CLEAR_MISSION_REQUEST_MESSAGE";

// Mine
export const GET_MY_MISSION_REQUESTS_REQUEST = "GET_MY_MISSION_REQUESTS_REQUEST";
export const GET_MY_MISSION_REQUESTS_SUCCESS = "GET_MY_MISSION_REQUESTS_SUCCESS";
export const GET_MY_MISSION_REQUESTS_FAIL = "GET_MY_MISSION_REQUESTS_FAIL";

export const GET_MY_CREATED_MISSION_REQUESTS_REQUEST = "GET_MY_CREATED_MISSION_REQUESTS_REQUEST";
export const GET_MY_CREATED_MISSION_REQUESTS_SUCCESS = "GET_MY_CREATED_MISSION_REQUESTS_SUCCESS";
export const GET_MY_CREATED_MISSION_REQUESTS_FAIL = "GET_MY_CREATED_MISSION_REQUESTS_FAIL";

// Get single request
export const GET_MISSION_REQUEST_REQUEST = "GET_MISSION_REQUEST_REQUEST";
export const GET_MISSION_REQUEST_SUCCESS = "GET_MISSION_REQUEST_SUCCESS";
export const GET_MISSION_REQUEST_FAIL = "GET_MISSION_REQUEST_FAIL";

// Create
export const CREATE_MISSION_REQUEST_REQUEST = "CREATE_MISSION_REQUEST_REQUEST";
export const CREATE_MISSION_REQUEST_SUCCESS = "CREATE_MISSION_REQUEST_SUCCESS";
export const CREATE_MISSION_REQUEST_FAIL = "CREATE_MISSION_REQUEST_FAIL";

// Duplicate
export const DUPLICATE_MISSION_REQUEST_REQUEST = "DUPLICATE_MISSION_REQUEST_REQUEST";
export const DUPLICATE_MISSION_REQUEST_SUCCESS = "DUPLICATE_MISSION_REQUEST_SUCCESS";
export const DUPLICATE_MISSION_REQUEST_FAIL = "DUPLICATE_MISSION_REQUEST_FAIL";

// Cancel
export const CANCEL_MISSION_REQUEST_REQUEST = "CANCEL_MISSION_REQUEST_REQUEST";
export const CANCEL_MISSION_REQUEST_SUCCESS = "CANCEL_MISSION_REQUEST_SUCCESS";
export const CANCEL_MISSION_REQUEST_FAIL = "CANCEL_MISSION_REQUEST_FAIL";

// Manager inbox
export const GET_MANAGER_MISSION_INBOX_REQUEST = "GET_MANAGER_MISSION_INBOX_REQUEST";
export const GET_MANAGER_MISSION_INBOX_SUCCESS = "GET_MANAGER_MISSION_INBOX_SUCCESS";
export const GET_MANAGER_MISSION_INBOX_FAIL = "GET_MANAGER_MISSION_INBOX_FAIL";

// Manager decision
export const MANAGER_MISSION_DECISION_REQUEST = "MANAGER_MISSION_DECISION_REQUEST";
export const MANAGER_MISSION_DECISION_SUCCESS = "MANAGER_MISSION_DECISION_SUCCESS";
export const MANAGER_MISSION_DECISION_FAIL = "MANAGER_MISSION_DECISION_FAIL";

// Manager history
export const GET_MANAGER_MISSION_HISTORY_REQUEST = "GET_MANAGER_MISSION_HISTORY_REQUEST";
export const GET_MANAGER_MISSION_HISTORY_SUCCESS = "GET_MANAGER_MISSION_HISTORY_SUCCESS";
export const GET_MANAGER_MISSION_HISTORY_FAIL = "GET_MANAGER_MISSION_HISTORY_FAIL";

// Admin inbox
export const GET_ADMIN_MISSION_INBOX_REQUEST = "GET_ADMIN_MISSION_INBOX_REQUEST";
export const GET_ADMIN_MISSION_INBOX_SUCCESS = "GET_ADMIN_MISSION_INBOX_SUCCESS";
export const GET_ADMIN_MISSION_INBOX_FAIL = "GET_ADMIN_MISSION_INBOX_FAIL";

// Admin decision
export const ADMIN_MISSION_DECISION_REQUEST = "ADMIN_MISSION_DECISION_REQUEST";
export const ADMIN_MISSION_DECISION_SUCCESS = "ADMIN_MISSION_DECISION_SUCCESS";
export const ADMIN_MISSION_DECISION_FAIL = "ADMIN_MISSION_DECISION_FAIL";

// Admin history
export const GET_ADMIN_MISSION_HISTORY_REQUEST = "GET_ADMIN_MISSION_HISTORY_REQUEST";
export const GET_ADMIN_MISSION_HISTORY_SUCCESS = "GET_ADMIN_MISSION_HISTORY_SUCCESS";
export const GET_ADMIN_MISSION_HISTORY_FAIL = "GET_ADMIN_MISSION_HISTORY_FAIL";

// Admin all requests
export const GET_ALL_MISSION_REQUESTS_REQUEST = "GET_ALL_MISSION_REQUESTS_REQUEST";
export const GET_ALL_MISSION_REQUESTS_SUCCESS = "GET_ALL_MISSION_REQUESTS_SUCCESS";
export const GET_ALL_MISSION_REQUESTS_FAIL = "GET_ALL_MISSION_REQUESTS_FAIL";

export const CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST = 'CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST';
export const CREATE_MISSION_REQUEST_FOR_COLLAB_SUCCESS = 'CREATE_MISSION_REQUEST_FOR_COLLAB_SUCCESS';
export const CREATE_MISSION_REQUEST_FOR_COLLAB_FAIL = 'CREATE_MISSION_REQUEST_FOR_COLLAB_FAIL';

// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

// ===================== COMMON =====================
export const setMissionRequestLoading = (value) => ({
    type: SET_MISSION_REQUEST_LOADING,
    payload: !!value,
});

export const clearMissionRequestMessage = () => ({
    type: CLEAR_MISSION_REQUEST_MESSAGE,
});

// ===================== MINE =====================
export const getMyMissionRequestsRequest = () => ({
    type: GET_MY_MISSION_REQUESTS_REQUEST,
});
export const getMyMissionRequestsSuccess = (data) => ({
    type: GET_MY_MISSION_REQUESTS_SUCCESS,
    payload: data,
});
export const getMyMissionRequestsFail = (error) => ({
    type: GET_MY_MISSION_REQUESTS_FAIL,
    payload: error,
});

export const getMyCreatedMissionRequestsRequest = (createdAsRole) => ({
    type: GET_MY_CREATED_MISSION_REQUESTS_REQUEST,
    payload: createdAsRole,
});
export const getMyCreatedMissionRequestsSuccess = (data) => ({
    type: GET_MY_CREATED_MISSION_REQUESTS_SUCCESS,
    payload: data,
});
export const getMyCreatedMissionRequestsFail = (error) => ({
    type: GET_MY_CREATED_MISSION_REQUESTS_FAIL,
    payload: error,
});

// ===================== GET SINGLE =====================
export const getMissionRequestRequest = (id) => ({
    type: GET_MISSION_REQUEST_REQUEST,
    payload: id,
});
export const getMissionRequestSuccess = (data) => ({
    type: GET_MISSION_REQUEST_SUCCESS,
    payload: data,
});
export const getMissionRequestFail = (error) => ({
    type: GET_MISSION_REQUEST_FAIL,
    payload: error,
});

// ===================== CREATE =====================
export const createMissionRequestRequest = (payload) => ({
    type: CREATE_MISSION_REQUEST_REQUEST,
    payload,
});
export const createMissionRequestSuccess = (data) => ({
    type: CREATE_MISSION_REQUEST_SUCCESS,
    payload: data,
});
export const createMissionRequestFail = (error) => ({
    type: CREATE_MISSION_REQUEST_FAIL,
    payload: error,
});

export const duplicateMissionRequestRequest = (id) => ({
    type: DUPLICATE_MISSION_REQUEST_REQUEST,
    payload: id,
});
export const duplicateMissionRequestSuccess = (data) => ({
    type: DUPLICATE_MISSION_REQUEST_SUCCESS,
    payload: data,
});
export const duplicateMissionRequestFail = (error) => ({
    type: DUPLICATE_MISSION_REQUEST_FAIL,
    payload: error,
});

export const createMissionRequestForCollabRequest = (payload) => ({
    type: CREATE_MISSION_REQUEST_FOR_COLLAB_REQUEST,
    payload
});

export const createMissionRequestForCollabSuccess = (data) => ({
    type: CREATE_MISSION_REQUEST_FOR_COLLAB_SUCCESS,
    payload: data
});

export const createMissionRequestForCollabFail = (error) => ({
    type: CREATE_MISSION_REQUEST_FOR_COLLAB_FAIL,
    error
});

// ===================== CANCEL =====================
export const cancelMissionRequestRequest = (id) => ({
    type: CANCEL_MISSION_REQUEST_REQUEST,
    payload: id,
});
export const cancelMissionRequestSuccess = (data) => ({
    type: CANCEL_MISSION_REQUEST_SUCCESS,
    payload: data,
});
export const cancelMissionRequestFail = (error) => ({
    type: CANCEL_MISSION_REQUEST_FAIL,
    payload: error,
});

// ===================== MANAGER INBOX =====================
export const getManagerMissionInboxRequest = () => ({
    type: GET_MANAGER_MISSION_INBOX_REQUEST,
});
export const getManagerMissionInboxSuccess = (data) => ({
    type: GET_MANAGER_MISSION_INBOX_SUCCESS,
    payload: data,
});
export const getManagerMissionInboxFail = (error) => ({
    type: GET_MANAGER_MISSION_INBOX_FAIL,
    payload: error,
});

// ===================== MANAGER DECISION =====================
export const managerMissionDecisionRequest = (payload) => ({
    type: MANAGER_MISSION_DECISION_REQUEST,
    payload,
});
export const managerMissionDecisionSuccess = (data) => ({
    type: MANAGER_MISSION_DECISION_SUCCESS,
    payload: data,
});
export const managerMissionDecisionFail = (error) => ({
    type: MANAGER_MISSION_DECISION_FAIL,
    payload: error,
});

// ===================== MANAGER HISTORY =====================
export const getManagerMissionHistoryRequest = () => ({
    type: GET_MANAGER_MISSION_HISTORY_REQUEST,
});
export const getManagerMissionHistorySuccess = (data) => ({
    type: GET_MANAGER_MISSION_HISTORY_SUCCESS,
    payload: data,
});
export const getManagerMissionHistoryFail = (error) => ({
    type: GET_MANAGER_MISSION_HISTORY_FAIL,
    payload: error,
});

// ===================== ADMIN INBOX =====================
export const getAdminMissionInboxRequest = () => ({
    type: GET_ADMIN_MISSION_INBOX_REQUEST,
});
export const getAdminMissionInboxSuccess = (data) => ({
    type: GET_ADMIN_MISSION_INBOX_SUCCESS,
    payload: data,
});
export const getAdminMissionInboxFail = (error) => ({
    type: GET_ADMIN_MISSION_INBOX_FAIL,
    payload: error,
});

// ===================== ADMIN DECISION =====================
export const adminMissionDecisionRequest = (payload) => ({
    type: ADMIN_MISSION_DECISION_REQUEST,
    payload,
});
export const adminMissionDecisionSuccess = (data) => ({
    type: ADMIN_MISSION_DECISION_SUCCESS,
    payload: data,
});
export const adminMissionDecisionFail = (error) => ({
    type: ADMIN_MISSION_DECISION_FAIL,
    payload: error,
});

// ===================== ADMIN HISTORY =====================
export const getAdminMissionHistoryRequest = () => ({
    type: GET_ADMIN_MISSION_HISTORY_REQUEST,
});
export const getAdminMissionHistorySuccess = (data) => ({
    type: GET_ADMIN_MISSION_HISTORY_SUCCESS,
    payload: data,
});
export const getAdminMissionHistoryFail = (error) => ({
    type: GET_ADMIN_MISSION_HISTORY_FAIL,
    payload: error,
});

// ===================== ADMIN ALL REQUESTS =====================
export const getAllMissionRequestsRequest = () => ({
    type: GET_ALL_MISSION_REQUESTS_REQUEST,
});
export const getAllMissionRequestsSuccess = (data) => ({
    type: GET_ALL_MISSION_REQUESTS_SUCCESS,
    payload: data,
});
export const getAllMissionRequestsFail = (error) => ({
    type: GET_ALL_MISSION_REQUESTS_FAIL,
    payload: error,
});
